import styled from "@emotion/styled";
import { colorGuide } from "../../theme/colors";

interface ToggleProps {
  checked: boolean;
  disabled: boolean;
}

const getBackgroundColor = (checked: boolean, disabled: boolean) => {
  if (checked) {
    return disabled
      ? colorGuide.lightComponents.toggleButton.checked.disabled.backgroundColor
      : colorGuide.lightComponents.toggleButton.checked.enabled.backgroundColor;
  } else {
    return disabled
      ? colorGuide.lightComponents.toggleButton.unchecked.disabled
          .backgroundColor
      : colorGuide.lightComponents.toggleButton.unchecked.enabled
          .backgroundColor;
  }
};

const getToggleColor = (checked: boolean, disabled: boolean) => {
  if (checked) {
    return disabled
      ? colorGuide.lightComponents.toggleButton.checked.disabled
          .toggleBackgroundColor
      : colorGuide.lightComponents.toggleButton.checked.enabled
          .toggleBackgroundColor;
  } else {
    return disabled
      ? colorGuide.lightComponents.toggleButton.unchecked.disabled
          .toggleBackgroundColor
      : colorGuide.lightComponents.toggleButton.unchecked.enabled
          .toggleBackgroundColor;
  }
};

export const ToggleWrapper = styled.div<ToggleProps>`
  display: flex;
  width: 40px;
  height: 40px;
  padding: 10px 3px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  -webkit-user-select: none;
`;

export const ToggleSlider = styled.div<ToggleProps>`
  width: 34px;
  height: 20px;
  background-color: ${({ checked, disabled }) =>
    getBackgroundColor(checked, disabled)};
  border-radius: 10px;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease;
  padding: 0 2px;
  cursor: ${({ disabled }) => (disabled ? "" : "pointer")};
`;

export const ToggleHandle = styled.div<ToggleProps>`
  width: 16px;
  height: 16px;
  background-color: ${({ checked, disabled }) =>
    getToggleColor(checked, disabled)};
  border-radius: 50%;
  transition: transform 0.3s ease;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
  transform: ${({ checked }) =>
    checked ? "translateX(14px)" : "translateX(0)"};
`;
